export default __webpack_public_path__ + "static/media/logo_lbdi.404924fc.svg";